import React, { ChangeEvent, SyntheticEvent } from 'react';
import { Async } from 'react-select';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Queries from '@api/graphql/queries';
import { ProductAutocomplete } from '@api/graphql/types';
import DeleteButton from '@components/DeleteButton';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';

export interface ProductIdName {
    id: string;
    name: string;
}

interface Props {
    name: string;
    onChange: (value: any, name: string) => void;
    products: ProductIdName[];
}

interface State {
    products: ProductIdName[] | null | undefined;
    newValue: string;
    newName: string;
}

type PropType = Props & InjectedIntlProps;

class ProductInput extends React.Component<PropType, State> {

    public constructor(props: PropType) {
        super(props);
        this.state = {
            newValue: '',
            newName: '',
            products: (this.props.products) ? [...this.props.products] : [],
        };
    }

    private handleNewValueChange = (e: ChangeEvent<HTMLInputElement>) => {
        this.setState({newValue: e.currentTarget.value});
    }

    private handleRemove = (index: number) => {
        let newValue: ProductIdName[] = [];
        if (this.state.products) {
            this.state.products.splice(index, 1);
            newValue = this.state.products;
         }
        this.onChange(newValue);
    }

    private handleAdd = (e: SyntheticEvent) => {
        e.preventDefault();
        if (this.state.newValue) {
            const newValue = this.state.products ? [...this.state.products, {id: this.state.newValue, name: this.state.newName}] : [{id: this.state.newValue, name: this.state.newName}];
            this.setState({newValue: '', newName: ''});
            this.onChange(newValue);
            this.setState({ products: newValue });
        }
    }

    private onChange = (products: ProductIdName[]) => {
        this.props.onChange(products, this.props.name);
    }

    private renderField = (value: any, index: number) => {
        return (
            <div className="row" key={`${name}-${index}`} style={{marginBottom: '5px'}}>
                <div className="col-sm-2">
                    {value.id}
                </div>
                <div className="col-sm-7">
                    {value.name}
                </div>
                <div className="col-sm-2">
                    <DeleteButton
                        className="btn-block"
                        onClick={this.handleRemove}
                        value={index}
                    />
                </div>
            </div>
        );
    }

    private loadOptions = (inputValue: string) => {
        const values = this.state.products ? this.state.products.map((val) => val.id) : [];
        return new Promise(resolve => {
            const filters = {
                name: parseInt(inputValue, 10) ? undefined : inputValue,
                ext_id: parseInt(inputValue, 10) ? inputValue : undefined,
            };
            GraphQLClient.query<ProductAutocomplete>({query: Queries.productAutocomplete, variables: {filters, count: 30, page: 1}})
                .then(options => {
                    if (options.data.adminProducts && options.data.adminProducts.data) {
                        resolve(options.data.adminProducts.data.filter((product) => {
                            return !values.includes(product.id);
                        })
                        .map((product) => {
                            return {value: product.id, label: product.name};
                        }));
                    }
                });
        });
    }

    public render() {
        return (
            <>
                {this.state.products ? this.state.products.map(this.renderField) : null}
                <div className="row">
                    <div className="col-sm-2">
                        <input
                            className="form-control col-sm-6"
                            type="text"
                            value={this.state.newValue}
                            onChange={this.handleNewValueChange}
                        />
                    </div>
                    <div className="col-sm-8 dropdownPadding">
                        <Async
                            loadOptions={this.loadOptions}
                            value={{value: this.state.newValue, label: this.state.newName}}
                            onChange={(value: {value: string, label: string}) => {
                                this.setState({newValue: value.value, newName: value.label});
                            }}
                        />
                    </div>
                    <div className="col-sm-2">
                        <button className="btn btn-primary btn-block" onClick={this.handleAdd}>
                            {this.props.intl.formatMessage({id: 'common.add'})}
                        </button>
                    </div>
                </div>
            </>
        );
    }
}

export default compose(
    injectIntl,
)(ProductInput);



// WEBPACK FOOTER //
// ./src/modules/Coupon/components/ProductInput.tsx